import { MDBIcon, MDBInput, MDBDataTable } from 'mdbreact';
import React, { Component } from 'react';
import { SegurosConfigPreguntas_ } from '../../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import '../../Pages/StylesAdmin.css';

const validate = values => {
    const errors = {}

    if (values.idtiposeguro === 'DEFAULT') {
        errors.idtiposeguro = 'campo obligatorio'
    }

    if (values.prioridad === 'DEFAULT') {
        errors.prioridad = 'campo obligatorio'
    }

    if (!values.titulopreg) {
        errors.titulopreg = 'campo obligatorio'
    }
    if (!values.descpregfrec1) {
        errors.descpregfrec1 = 'campo obligatorio'
    }
    return errors;
};

class Preguntas extends Component {
    //RQTO. CDAT Y AHORRO DIGITAL, REAJUSTE YC
    uploader = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            estadoNuevo: false,
            errors: {},
            estadoSinInfo: false,
            infoConveniosDetalles: [],
            idsegupregunta: null,
            prioridad: 'DEFAULT',
            idtipopers: 'DEFAULT',
            titulopreg: '',
            descpregfrec1: '',
            editprioridad: 'DEFAULT',
            edittitulopreg: '',
            editdescpregfrec1: '',
            estadoCambio: true,
            estado: null,
            boolprioridad: false,
            nombreboton: 'Guardar'
        };
    }

    async componentDidMount() {
        this.cargarInformacion();
    }

    cargarInformacion = () => {
        const data = {
            tran: 4,
            idsegupregunta: 0,
            idtiposeguro: 0,
            titulo: 'NA',
            descripcion: 'NA',
            orden: 0,
            estado: 1,
            idusucrea: parseInt(sessionStorage.getItem('idusuario')),
            feccrea: null,
        }
        SegurosConfigPreguntas_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (!response.data[0].message) {
                        this.setState({
                            idSeleccionado: response.data[0].idsegupregunta
                        })
                        setTimeout(() => {
                            this.setState({
                                infoConveniosDetalles: response.data,
                                estado: response.data[0].estado,
                                estadoSinInfo: true,
                                estadoImagen: true,
                            })
                        }, 120);
                    } else {
                        this.setState({
                            estadoSinResultados: false,
                            estadoNuevo: true,
                            estadoCambioImg1: true,
                            estadoSinInfo: false
                        })
                    }
                } else { }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    text: 'Ocurrio un error al consumir el servicio!'
                })
            }
        });
    }

    textInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    cambio = (name, file) => {
        this.setState({
            estadoCambio: true
        });
    }

    TransarDatos = (id) => {
        const { errors, ...sinErrors } = this.state;
        const result = validate(sinErrors);
        this.setState({ errors: result });

        if (!Object.keys(result).length) {
            let letidpregfrecuente = 0;

            if (id != null) {
                letidpregfrecuente = id.idsegupregunta;
            }

            //FORMULARIO VALIDADO
            const data = {
                tran: 1,
                idsegupregunta: letidpregfrecuente,
                idtiposeguro: parseInt(this.state.idtiposeguro),
                titulo: this.state.titulopreg,
                descripcion: this.state.descpregfrec1,
                orden: parseInt(this.state.prioridad),
                estado: 1,
                idusucrea : parseInt(sessionStorage.getItem('idusuario')),
                feccrea: null,
            }
            SegurosConfigPreguntas_(data).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].message === "000000") {
                        Swal.fire({
                            icon: 'success',
                            title: id == null ? 'Se agrego correctamente.' : 'Se actualizo satisfactoriamente'
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: id == null ? 'Error al insertar.' : 'Ocurrio un error al actualizar'
                        });
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un error!'
                    });
                }

                //AQUI LIMPIO LA INFORMACIÓN
                this.limpiarInformacionFormulario();
                //AQUI CARGO LA INFOMACIÓN
                this.cargarInformacion();
            });
        }
    }

    editar = (id) => {
        var seleccionado = [];
        this.state.infoConveniosDetalles.map((e) => {
            if (e.idsegupregunta === id) {
                seleccionado.push(e)
            }
            return [];
        })
        this.setState({
            idsegupregunta: seleccionado[0].idsegupregunta,
            edittitulopreg: seleccionado[0].titulopreg,
            editdescpregfrec1: seleccionado[0].descpregfrec1,
            editidtiposeguro: seleccionado[0].idtiposeguro,
            editprioridad: seleccionado[0].prioridad,
            estadoEditar: true
        })
    }

    activar = (id) => {
        const data = {
            tran: 6,
            idsegupregunta: id,
            idtiposeguro: 0,
            titulo: 'NA',
            descripcion: 'NA',
            orden: 0,
            estado: 1,
            idusucrea: parseInt(sessionStorage.getItem('idusuario')),
            feccrea: null,
        }

        SegurosConfigPreguntas_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se activo satisfactoriamente'
                });
                this.cargarInformacion();
            }
        });
    }

    inactivar = (id) => {
        const data = {
            tran: 6,
            idsegupregunta: id,
            idtiposeguro: 0,
            titulo: 'NA',
            descripcion: 'NA',
            orden: 0,
            estado: 0,
            idusucrea: parseInt(sessionStorage.getItem('idusuario')),
            feccrea: null,
        }
        SegurosConfigPreguntas_(data).then(response => {
            if (response) {
                this.setState({
                    estadoS: false
                })
                Swal.fire({
                    icon: 'success',
                    title: 'Se inactivo satisfactoriamente'
                });
                this.cargarInformacion();
            }
        });
    }

    limpiarInformacionFormulario = () => {
        this.setState({
            estadoNuevo: false,
            registroSeleccionado: null,
            prioridad: 'DEFAULT',
            idtiposeguro: 'DEFAULT',
            titulopreg: '',
            descpregfrec1: '',
            boolprioridad: false,
            nombreboton: 'Guardar',
            estadoCambio: true,
            errors: {}
        });
    }

    handleNew = (registro) => {
        //AQUI LIMPIO LA INFORMACIÓN
        this.limpiarInformacionFormulario();
        this.setState({ estadoNuevo: !this.state.estadoNuevo, });

        if (registro == null) {
            if (this.state.estadoNuevo) {
                this.cargarInformacion();
            }
        }
        else {
            this.setState({
                registroSeleccionado: registro,
                prioridad: registro.prioridad,
                titulopreg: registro.titulo,
                descpregfrec1: registro.descripcion,
                idtiposeguro: registro.idtiposeguro,
                editprioridad: registro.orden,
                nombreboton: 'Editar',
                estadoCambio: false
            });
        }
    }

    render() {
        const { estadoNuevo, estadoSinInfo, errors, infoConveniosDetalles } = this.state;

        const tiposseguros = [
            { idtiposeguro: 1, descripcion: 'PREVISIÓN EXEQUIAL' },
            { idtiposeguro: 2, descripcion: 'PROTECCIÓN' }
        ];

        return (
            <React.Fragment>
                <p className="font-weight-bold">Preguntas Seguros</p>
                <hr />
                {estadoSinInfo ? (
                    <React.Fragment>
                        <div style={{ position: 'absolute', right:'5px', top: '0px', cursor:'pointer' }} className="align-items-center d-flex" onClick={() => { this.handleNew(null) }}>
                            {estadoNuevo ? <p>Cancelar &nbsp;<MDBIcon icon="times" size="lg" /></p> : <p>Agregar Nuevo &nbsp;<MDBIcon icon="plus-circle" size="lg" /></p>}
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment></React.Fragment>
                )}
                {estadoNuevo ? (
                    <React.Fragment>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mb-2">
                                    <label>Tipo de Seguro</label>
                                    <select name="idtiposeguro" className="form-control" value={this.state.idtiposeguro} onChange={this.textInput} >
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        {tiposseguros.map(tiposeg => <option key={tiposeg.idtiposeguro} value={tiposeg.idtiposeguro}> {tiposeg.descripcion}</option>)}
                                    </select>
                                    {errors.idtiposeguro && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.idtiposeguro}</strong>}
                                </div>

                                <div className="col-md-12 my-2">
                                    <MDBInput label="Titulo Pregunta" name="titulopreg" type="text" value={this.state.titulopreg} onChange={this.textInput} />
                                    {errors.titulopreg && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', top: '50px' }}>{errors.titulopreg}</strong>}
                                </div>

                                <div className="col-md-12 my-2">
                                    <MDBInput label="Descripción" name="descpregfrec1" type="textarea" rows="4" value={this.state.descpregfrec1} onChange={this.textInput} />
                                    {errors.descpregfrec1 && <strong className="text-danger" style={{ fontSize: '13px', position: 'absolute', marginTop: '-30px' }}>{errors.descpregfrec1}</strong>}
                                </div>

                                <div className="col-md-12 my-2">
                                    <label>Orden/Ubicación</label>
                                    <select name="prioridad" className="form-control" value={this.state.prioridad} disabled={this.state.boolprioridad} onChange={this.textInput} >
                                        <option value="DEFAULT" disabled>Seleccione...</option>
                                        <option value="0">Principal</option>
                                        <option value="1">Más preguntas</option>
                                    </select>
                                    {errors.prioridad && <strong className="text-danger" style={{ fontSize: '13px' }}>{errors.prioridad}</strong>}
                                </div>
                            </div>
                        </div>
                        <div className="pt-2 mt-5 modal-footer w-100">
                            <button type="button" className="btn btn-primary px-5" onClick={() => this.TransarDatos(this.state.registroSeleccionado)}>{this.state.nombreboton} Producto &nbsp; <MDBIcon icon="save" /></button>
                        </div>
                    </React.Fragment>
                ) : (
                        <React.Fragment>
                            <MDBDataTable 
                            striped
                            bordered
                            hover
                            className="pregunta-seguro"
                            data={{
                                columns: [
                                    { label: 'Prioridad Posición', field: 'prioridad' },
                                    { label: 'Tipo Seguro', field: 'idtiposeguro' },
                                    { label: 'Titulo Pregunta', field: 'titulopreg' },
                                    { label: 'Descripción 1', field: 'desc1' },
                                    { label: 'Editar', field: 'editar' },
                                    { label: 'Inactivar', field: 'inactivar' },
                                ],
                                rows: infoConveniosDetalles.map((e) => {
                                    const tipoPrioridad = e.orden === 1 ? 'Inferior' : 'Superior';
                                    const icono = e.estado === 1
                                        ? <MDBIcon icon="eye" size="2x" style={{ cursor: 'pointer' }} onClick={() => this.inactivar(e.idsegupregunta)} />
                                        : <MDBIcon icon="eye-slash" size="2x" style={{ cursor: 'pointer' }} onClick={() => this.activar(e.idsegupregunta)} />;
                                    return {
                                        prioridad: tipoPrioridad,
                                        titulopreg: e.titulo,
                                        desc1: e.descripcion,
                                        idtiposeguro: e.idtiposeguro,
                                        editar: (
                                            <MDBIcon icon="edit" size="2x" style={{ color: 'green', cursor: 'pointer' }}
                                                onClick={() => this.handleNew(e)} />
                                        ),
                                        inactivar: icono
                                    };
                                })
                            }}
                        />
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default Preguntas;